module.exports = __webpack_public_path__ + "img/day5.dd8c9f63.jpeg";